import { Badge as HeroBadge } from '@heroui/react';
import { ReactNode } from 'react';

export interface BadgeProps {
  content?: ReactNode;
  color?: 'default' | 'accent' | 'success' | 'warning' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'soft';
  placement?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  children?: ReactNode;
}

export const Badge = ({
  content,
  color = 'danger',
  size = 'md',
  variant = 'primary',
  placement = 'top-right',
  children,
}: BadgeProps) => {
  if (!content && content !== 0) {
    return <>{children}</>;
  }

  if (!children) {
    return (
      <HeroBadge color={color} size={size} variant={variant}>
        {content}
      </HeroBadge>
    );
  }

  return (
    <HeroBadge.Anchor>
      <HeroBadge
        color={color}
        size={size}
        variant={variant}
        placement={placement}
      >
        {content}
      </HeroBadge>
      {children}
    </HeroBadge.Anchor>
  );
};
